import type { CmsScreen } from '../cmsScreenRegistry';

/**
 * Placeholder for a CMS Admin screen whose module has not been ported yet.
 *
 * Phase 7 run 1 builds the SHELL only; all 31 feature modules are `pending`.
 * The route is DORMANT (`django/cms_admin/urls.py` still serves the Backbone
 * `CMSHomeView`), so no user ever sees this — it exists so the shell can be
 * navigated and verified end-to-end, and so a tranche has an obvious target to
 * replace.
 *
 * Deliberately plain: it must never be mistaken for a finished screen.
 */
const CmsPendingScreen = ({ screen }: { screen?: CmsScreen }) => {
  if (!screen) return null;
  return (
    <div className="cms-pending-screen" data-cms-pending={screen.key}>
      <h1 className="cms-heading__title">{screen.key}</h1>
      <p>
        Not yet migrated — legacy module <code>cms/mvc/{screen.module}</code>, tranche{' '}
        <strong>{screen.tranche}</strong>.
      </p>
      <p>
        See <code>frontend/PHASE7_CMS_SURVEY.md</code> §5 for the sequencing plan. To land this
        screen, add its component and flip <code>status</code> to <code>&apos;live&apos;</code> in{' '}
        <code>cmsScreenRegistry.ts</code>.
      </p>
    </div>
  );
};

export default CmsPendingScreen;
